
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vzdelavacie-programy",
      function () {
        return require("private-next-pages/vzdelavacie-programy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vzdelavacie-programy"])
      });
    }
  